import React from 'react';
import { Icon } from '@noths/polaris-design-system-core-components';

import { roundAverageProductRating } from 'src/utils/roundAverageProductRating';
import * as styles from './ProductRating.styles';

export interface ProductRatingProps {
  averageRating?: number;
  numberOfReviews?: number;
  onReviewsLinkClick?: (evt: React.MouseEvent<HTMLAnchorElement>) => void;
  reviewsLinkHref: string;
}

export const ProductRating = ({
  averageRating,
  numberOfReviews = 0,
  onReviewsLinkClick = () => {},
  reviewsLinkHref,
}: ProductRatingProps) => {
  const showRating = Boolean(averageRating);
  const formattedNumberOfReviews = numberOfReviews.toLocaleString('en-GB');

  if (!showRating) {
    return null;
  }

  return (
    <a css={styles.reviewsLink} href={reviewsLinkHref} onClick={onReviewsLinkClick}>
      <b>{roundAverageProductRating(averageRating)}</b>
      <Icon name="starFull" size="sm" />
      {numberOfReviews && <small>({formattedNumberOfReviews})</small>}
    </a>
  );
};
